module.exports = "td.myclass\n{\n    white-space:pre-wrap!important;\n}\ntable.myclass{\n    white-space:pre-wrap!important;\n    text-align: justify;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/repository/repository.component.css
// module id = ./src/app/repository/repository.component.css
// module chunks = main